<template>
    <div class="mtable-ctn">

        <table cellspacing="0" cellpadding="0" class="mtable">
            <tr class="row--label" v-if="showLabels && labels">
                <th v-for="(label, labelIndex) in labels" :key="labelIndex">
                    {{ label.label }}
                </th>
            </tr>
            <tr
                @click="rowClicked(row)"
                @mouseenter="isActive = true"
                @mouseleave="isActive = false"
                class="row--data"
                :class="cellClass(rowIndex)"
                v-for="(row, rowIndex) in rows"
                :key="rowIndex"
            >
                <template v-for="(cell, cellIndex) in row" :key="`${rowIndex}_${cellIndex}`">
                    <td :class="{multi: Array.isArray(cell)}" v-if="cellIndex.toString() !== '$id' && cellIndex.toString() !== '$actions'">
                        <template v-if="Array.isArray(cell)">
                            <template v-for="(atom, atomIndex) in cell" :key="atomIndex">
                                <p v-if="atomIndex==0">{{ atom }}</p>
                                <span v-else>{{ atom }}</span>
                            </template>
                        </template>
                        <template v-else-if="isCellObject(cell)">
                            <!-- Cellule enrichie : valeur + icône
                                 optionnelle avec tooltip natif via
                                 `title`. Permet de signaler une
                                 caractéristique (ex: assurance) sans
                                 surcharger le contenu. -->
                            <span class="cell-with-icon">
                                <span>{{ (cell as CellObject).value }}</span>
                                <span
                                    v-if="(cell as CellObject).icon"
                                    class="cell-icon"
                                    :title="(cell as CellObject).title || ''"
                                >
                                    <IconSvg :name="(cell as CellObject).icon!" />
                                </span>
                            </span>
                        </template>
                        <template v-else>{{ cell }}</template>
                    </td>
                    <td v-if="cellIndex.toString() === '$actions'">
                        <div @click="rowActionClicked(row, item.name)" class="action" v-for="(item, index) in (cell as unknown as RowAction[])" :key="index">
                            <IconSvg v-if="item.icon" class="type-fill" :name="item.icon" />
                            <span v-else>{{ item.label }}</span>
                        </div>
                    </td>
                </template>
            </tr>
        </table>
    </div>
</template>
<script setup lang="ts">
    import { ref, toRefs } from 'vue'
    import IconSvg from '@/components/atoms/ASvg.vue'

    const emit = defineEmits(['clicked', 'rowActionClicked'])

    interface Props {
        rows: object,
        labels: rowLabel[],
        showLabels: boolean,
        selectable: boolean
    }

    interface rowLabel {
        label: string,
        value: string,
        align?: string
    }

    interface RowAction {
        name: string,
        icon?: string,
        label?: string
    }

    interface CellObject {
        value: string | number,
        icon?: string,
        title?: string,
    }

    const isCellObject = (cell: unknown): cell is CellObject => {
        return (
            cell !== null &&
            typeof cell === 'object' &&
            !Array.isArray(cell) &&
            'value' in (cell as Record<string, unknown>)
        )
    }

    const props = withDefaults(defineProps<Props>(), {
        showLabels: false,
        labels: null,
        rows: null,
        selectable: false
    })

    const isActive = ref(false)

    const { rows, labels } = toRefs(props)

    const cellClass = (index) => {
        const classes = []
        if (index%2 === 0) {
            classes.push('odd')
        }
        else {
            classes.push('even')
        }
        if (props.selectable) {
            classes.push('selectable')
        }
        return classes
    }

    const rowActionClicked = ((row, action) => {
        emit('rowActionClicked', row, action);
    })

    const rowClicked = ((row) => {
        emit('clicked', row);
    })

</script>
